import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';

import SmileyIcon from '../svgs/SmileyIcon';

const SMILEY_SIZE = 40;
const SMILEY_GAP = 12;

const smileyVariants = [
  {
    key: 'hurts-worst', label: 'Hurts the worst!', value: 6, color: '#731C0C',
  },
  {
    key: 'hurts-whole-lot', label: 'Hurts a whole lot!', value: 5, color: '#6C2C0E',
  },
  {
    key: 'hurts-even-more', label: 'Hurts even more', value: 4, color: '#6C4C10',
  },
  {
    key: 'hurts-little-more', label: 'Hurts a little more', value: 3, color: '#6E6C0E',
  },
  {
    key: 'hurts-little', label: 'Hurts a little', value: 2, color: '#406B0F',
  },
  {
    key: 'no-pain', label: 'No pain!', value: 1, color: '#106F0D',
  },
];

const RatingSmiley = ({
  rating,
  onSelect,
  labelsMap,
}) => {
  const clampedRating = Math.max(0, Math.min(rating, smileyVariants.length));
  const selectedVariant = smileyVariants.find((s) => s.value === clampedRating);

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="column"
      width="100%"
    >
      <Box
        display="flex"
        alignItems="flex-start"
        gap={`${SMILEY_GAP}px`}
        width="100%"
      >
        {smileyVariants.map((smiley) => {
          const { value } = smiley;
          const isSelected = value === clampedRating;
          const isUnselected = clampedRating > 0 && !isSelected;

          // Determine the state: default, selected, or unselected
          let smileyState = 'default';
          if (isSelected) {
            smileyState = 'selected';
          } else if (isUnselected) {
            smileyState = 'unselected';
          }

          return (
            <Box
              key={smiley.key}
              display="flex"
              flexDirection="column"
              alignItems="center"
              flex={1}
            >
              <ButtonBase
                disableRipple
                focusRipple={false}
                onClick={() => onSelect && onSelect(value)}
                sx={{
                  width: SMILEY_SIZE,
                  height: SMILEY_SIZE,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 1,
                  transition: 'transform 0.3s ease-out',
                }}
              >
                <SmileyIcon
                  variant={smiley.key}
                  state={smileyState}
                  style={{
                    width: '100%',
                    height: '100%',
                    transition: 'opacity 0.3s ease-out, filter 0.3s ease-out',
                    transform: isSelected ? 'scale(1.34)' : 'scale(1)',
                  }}
                />
              </ButtonBase>
            </Box>
          );
        })}
      </Box>
      {selectedVariant && (
        <Typography
          variant="caption"
          sx={{
            marginTop: '6px',
            color: selectedVariant.color,
            fontWeight: 800,
            fontSize: '14px',
          }}
        >
          {labelsMap?.[clampedRating] || selectedVariant.label}
        </Typography>
      )}
    </Box>
  );
};

RatingSmiley.propTypes = {
  rating: PropTypes.number,
  onSelect: PropTypes.func,
  labelsMap: PropTypes.objectOf(PropTypes.string),
};

RatingSmiley.defaultProps = {
  rating: 0,
  onSelect: undefined,
  labelsMap: undefined,
};

export default RatingSmiley;
